import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import AWSCognitoUserPool from "../../shared/api/AWSCognitoUserPool";
import styles from "./support.module.scss";

const SupportPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    subject: "",
    description: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [modalStatus, setModalStatus] = useState("success");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const templateParams = {
      email: formData.email,
      subject: formData.subject,
      message: formData.description,
    };

    emailjs
      .send(
        "service_2gfg7gj",
        "template_rmcg7h8",
        templateParams,
        "ZqY0jQjqKQlpblJLS"
      )
      .then(() => {
        setModalStatus("success");
        setShowModal(true);
        setFormData({ email: "", subject: "", description: "" });
      })
      .catch(() => {
        setModalStatus("error");
        setShowModal(true);
      });
  };

  useEffect(() => {
    const currentUser = AWSCognitoUserPool.getCurrentUser();
    if (currentUser) {
      currentUser.getSession((err, session) => {
        if (err) {
          console.error('Error getting user session:', err);
          return;
        }
        if (session.isValid()) {
          currentUser.getUserAttributes((err, attributes) => {
            if (err) {
              console.error('Error getting user attributes:', err);
              return;
            }
            const emailAttribute = attributes.find(attr => attr.Name === 'email');
            if (emailAttribute) {
              setFormData(prev => ({ ...prev, email: emailAttribute.Value }));
              console.log('User email:', emailAttribute.Value);
            }
          });
        }
      });
    }
  }, []);

  return (
    <div className={styles.supportpage}>
      <h1>Need Help? We’re Here for You!</h1>
      <p className={styles.introText}>
        Our team is ready to assist you.
        <br />
        <span className={styles.highlightText}>
          Just drop your request below and we’ll get back to you as soon as
          possible
        </span>
      </p>
      <form onSubmit={handleSubmit}>

        <div className={styles.formgroup}>
          <label>Email</label>
          <input
            type="mail"
            name="email"
            placeholder="Enter your Mail ID"
            value={formData.email}
            onChange={handleChange}
            required
            enabled={formData.email !== ''}
          />
        </div>
        <div className={styles.formgroup}>
          <label>Subject</label>
          <input
            type="text"
            name="subject"
            placeholder="Subject of your request"
            value={formData.subject}
            onChange={handleChange}
            required
          />
        </div>

        <div className={styles.formgroup}>
          <label>Description</label>
          <textarea
            name="description"
            placeholder="Describe your issue..."
            value={formData.description}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit">Submit</button>
      </form>

      {showModal && (
        <div className={styles.modaloverlay}>
          <div className={styles.modalcontent}>
            <h2>{modalStatus === "success" ? "Thank you!" : "Oops!"}</h2>
            <p>
              {modalStatus === "success"
                ? "Your request has been sent successfully. Our team will assist you soon!"
                : "Something went wrong. Please try again later."}
            </p>
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupportPage;
